/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React, { useState, useEffect } from "react";
import { Button } from "vr-react-components";
import { Text } from "vr-react-components";
import { Input } from "vr-react-components";
import { useDispatch, useSelector } from "react-redux";
import { handleSetKeyboard } from "../../handlers/PrivateHandlers";
import { setLastInvitedUsers } from "../../store/slice/privateSlice";

function MicrosoftTeamsPanel({ width, height, data, onClose, aframeClasses, ...otherAttributes }) {
    const lastInvitedUsers = useSelector((state) => state.private.lastInvitedUsers);

    const [usersEmails, setUsersEmails] = useState("");
    const [groupTitle, setGroupTitle] = useState("T-VREX troubleshooting session");
    const [isInputFocused, setIsInputFocused] = useState(false);

    const dispatch = useDispatch();

    const emailRegex = /^\S+@\S+\.\S+$/;

    useEffect(() => {
        return () => {
            handleSetKeyboard("us", false, null);
        };
    }, []);

    const drawLastInvitedUsers = () => {
        return lastInvitedUsers.slice(0, 4).map((user, id) => {
            return (
                <Button
                    key={id}
                    text={user}
                    width={width * 0.45}
                    height={height * 0.1}
                    type={Button.constants.primary}
                    textSizeDecimal={25 / (width * 0.45)}
                    aframeClasses={aframeClasses}
                    position={`${width * 0.225 + width * 0.45 * (id % 2)} ${-height * 0.1 * Math.floor(id / 2)
                        } 0`}
                    onClickHandler={() => {
                        setUsersEmails((old) => {
                            if (!old.includes(user))
                                return !old || old.slice(-1) === ","
                                    ? `${old}${user}`
                                    : `${old},${user}`;
                            else return old;
                        });
                    }}
                />
            );
        });
    };

    return (
        <a-entity
            position={`${-width / 2 + width * 0.05} ${height * 0.65} ${height / 100
                }`}
            {...otherAttributes}
        >
            <Text
                text="Invite your guests in a Microsoft Teams group"
                width={width}
                sizeDecimal={40 / width}
            />
            <Input
                width={width * 0.9}
                height={height * 0.1}
                aframeClasses={aframeClasses}
                position={`${width * 0.45} ${-height * 0.15} 0`}
                text={groupTitle}
                textSizeDecimal={40 / width}
                onClickHandler={() => {
                    handleSetKeyboard("us", true, (callback) => {
                        setGroupTitle((old) => callback(old));
                    });
                    setIsInputFocused("group");
                }}
                focused={isInputFocused === "group"}
            />
            <Input
                width={width * 0.9}
                height={height * 0.3}
                position={`${width * 0.45} ${-height * 0.4} 0`}
                text={usersEmails}
                textSizeDecimal={35 / width}
                aframeClasses={aframeClasses}
                onClickHandler={() => {
                    handleSetKeyboard("us", true, (callback) => {
                        setUsersEmails((old) => callback(old));
                    });
                    setIsInputFocused("emails");
                }}
                focused={isInputFocused === "emails"}
                crop={false}
            />
            
            <Button
                text="Back"
                width={width * 0.2}
                height={height * 0.13}
                type={Button.constants.dark}
                textSizeDecimal={40 / width}
                position={`${width * 0.1} ${-height * 0.75} 0`}
                aframeClasses={"collidable"}
                onClickHandler={onClose}
            />
            <Button
                text="Invite"
                width={width * 0.3}
                height={height * 0.13}
                type={Button.constants.primary}
                textSizeDecimal={40 / width}
                aframeClasses={aframeClasses}
                position={`${width * 0.75}  ${-height * 0.75} 0`}
                disabled={
                    usersEmails
                        .replace(" ", "")
                        .split(",")
                        .filter((x) => emailRegex.test(x)).length !==
                    usersEmails.split(",").length
                }
                onClickHandler={() => {
                    window.open(
                        `https://teams.microsoft.com/l/chat/0/0?users=${usersEmails.replace(
                            " ",
                            "",
                        )}&topicName=${encodeURI(groupTitle)}&message=${encodeURI(
                            `${window.location.origin}/cooperative/login/${data}`,
                        )}`,
                        "_blank",
                        "noopener",
                    );
                    const newUsers = [
                        ...new Set([
                            ...usersEmails.replace(" ", "").split(","),
                            ...lastInvitedUsers,
                        ]),
                    ];
                    dispatch(setLastInvitedUsers(newUsers));
                    onClose();
                }}
            />
            <a-entity position={`0 ${-height * 0.95} 0`}>
                {drawLastInvitedUsers()}
            </a-entity>
        </a-entity>
    );
}

export default MicrosoftTeamsPanel;
